import PropTypes from 'prop-types'
import { DetailsContainer as Container } from '@calendly/booking-kit'

const Details = ({ flow = 'column', ...props }) => (
  <Container data-container="details" flow={flow} {...props} />
)

Details.propTypes = {
  flow: PropTypes.oneOf(['column', 'row'])
}

export default Details
